import { TransferAssetResolverBase } from './transfer-asset.resolver.base';
import { TransferAssetService } from './transfer-asset.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class TransferAssetResolver extends TransferAssetResolverBase {

  constructor(protected service: TransferAssetService) {
    super(service);
  }
}



